import { AdminType, APIGet, APIPost, APIUrl } from "api/protocols";
import { CancelToken } from "axios";
import { ILoyaltyProgram, ILoyaltyProgramTransaction } from "redux/reducers/models/loyalty";

export interface ILoyaltyProgramTransactionExtended extends ILoyaltyProgramTransaction {
    order_number:number;
    order_sales_channel: string;
    source_order_id: number;
    facility_long_name: string;
    loyalty_program_offers_type: "welcome_bonus" | "amount_spent" | "points_adjustment" | "standalone_import" | "birthday_bonus";
}

export async function GetLoyaltyProgram(params: {include_enrollment?: boolean}, useGlobalLoader: boolean, token?: CancelToken) {
    return await APIGet<Array<ILoyaltyProgram>>(APIUrl(AdminType.Customer ,"/customer/loyalty"), params, useGlobalLoader, token);
}

export async function GetLoyaltyProgramTiers(params: {client_id: number}, useGlobalLoader: boolean, token?: CancelToken) {
    return await APIGet(APIUrl(AdminType.Customer ,"/customer/loyalty/tiers"), params, useGlobalLoader, token);
}

export async function GetLoyaltyProgramRewards(params: {client_id: number}, useGlobalLoader: boolean, token?: CancelToken) {
    return await APIGet(APIUrl(AdminType.Customer ,"/customer/loyalty/rewards"), params, useGlobalLoader, token);
}

export async function GetLoyaltyProgramCustomer(params: {loyalty_program_id: number}, useGlobalLoader: boolean, token?: CancelToken) {
    return await APIGet(APIUrl(AdminType.Customer ,"/customer/loyalty/customer"), params, useGlobalLoader, token);
}

export async function GetLoyaltyProgramCustomerExpiringPoints(params: {loyalty_program_id: number}, useGlobalLoader: boolean, token?: CancelToken) {
    return await APIGet(APIUrl(AdminType.Customer ,"/customer/loyalty/customer/expiring-points"), params, useGlobalLoader, token);
}

export async function GetLoyaltyProgramCustomerTransactions(params: {loyalty_program_id: number, limit?: number; offset?: number}, useGlobalLoader: boolean, token?: CancelToken) {
    return await APIGet<Array<ILoyaltyProgramTransactionExtended>>(APIUrl(AdminType.Customer ,"/customer/loyalty/customer/transactions"), params, useGlobalLoader, token);
}

export async function PostLoyaltyProgramCustomer(params: {client_id: number}, useGlobalLoader: boolean) {
    return await APIPost<Array<ILoyaltyProgramTransactionExtended>>(APIUrl(AdminType.Customer ,"/customer/loyalty/customer"), params, useGlobalLoader);
}